import React, { useEffect, useState } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import styled, { keyframes, css } from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import Text from 'ls-common-client/dist/components/Text';
import Button from 'ls-common-client/dist/components/Button';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const fadeAnimation = ({ show, animationDuration }) =>
  css`
    ${show ? fadeIn : fadeOut} ${animationDuration}ms
  `;

const FadeBackdrop = styled(Container)`
  display: flex;
  opacity: ${props => (props.show ? 1 : 0)};
  animation: ${fadeAnimation};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const FadeContainer = styled(Container)`
  display: flex;
  animation: ${fadeAnimation};
  width: 335px;
`;

const FormConfirmation = ({
  show,
  heading,
  text,
  children,
  buttons,
  animationDuration = 0,
  ...props
}) => {
  const [inDom, setInDom] = useState(false);
  const [containerRef, setContainerRef] = useState();

  useEffect(() => {
    if (show) {
      setInDom(true);
    } else {
      setTimeout(() => {
        setInDom(false);
      }, animationDuration);
    }
  }, [show, animationDuration, containerRef]);

  useEffect(() => {
    if (inDom && containerRef) {
      disableBodyScroll(containerRef);
    }
    if (!inDom && containerRef) {
      enableBodyScroll(containerRef);
    }
  }, [containerRef, inDom]);

  if (!inDom) return null;

  return (
    <FadeBackdrop
      position="fixed"
      zIndex="999999"
      top="0"
      left="0"
      right="0"
      bottom="0"
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor="rgba(0, 0, 0, 0.1)"
      padding="15px"
      show={show}
      animationDuration={animationDuration}
    >
      <FadeContainer
        ref={ref => {
          setContainerRef(ref);
        }}
        display="flex"
        flexDirection="column"
        border="solid 1px"
        borderColor="border300"
        backgroundColor="background100"
        boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.5)"
        width="100vw"
        maxHeight="100vh"
        show={show}
        animationDuration={animationDuration}
        overflow="auto"
        borderRadius="11px"
        padding="15px"
        {...props}
      >
        {heading && (
          <Text
            display="block"
            fontSize="18px"
            color="normal"
            fontWeight="600"
            lineHeight="1.2"
            marginBottom="13px"
          >
            {heading}
          </Text>
        )}
        {text && (
          <Text
            display="block"
            fontSize="16px"
            color="text400"
            lineHeight="1.2"
          >
            {text}
          </Text>
        )}
        {children}
        {buttons && !!buttons.length && (
          <Container display="flex" marginTop="18px">
            {buttons.map(button => (
              <Button
                key={button.children}
                fontSize="16px"
                height="44px"
                {...button.props}
              >
                {button.children}
              </Button>
            ))}
          </Container>
        )}
      </FadeContainer>
    </FadeBackdrop>
  );
};

export default FormConfirmation;
